export * from "./specifications.component";
